import axios from "axios";

import { getEnv } from "../helpers/env";
import https from "https";

export const axiosContentDetail = axios.create({
  baseURL: getEnv("AXIOS_CONTENT_DETAIL")
});

export const axiosUserManagement = axios.create({
  baseURL: getEnv("AXIOS_USER_MANAGEMENT")
});

export const axiosWebinarManagement = axios.create({
  baseURL: getEnv("AXIOS_API_MANAGEMENT")
});

export const axiosPortalSearch = axios.create({
  baseURL: getEnv("AXIOS_PORTAL_SEARCH")
});

export const axiosHomeScreen = axios.create({
  baseURL: getEnv("AXIOS_HOME_SCREEN")
});

export const axiosNotification = axios.create({
  baseURL: getEnv("AXIOS_NOTIFICATION")
});

export const axiosCmsAPI = axios.create({
  baseURL: getEnv("AXIOS_STOREFRONT")
});
